import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SharedAuthSessionManager, SharedAuthSessionOptions, SharedInvalidSessionHandler } from '@share-auth-session';
import { AuthActions } from '../store/state/auth/auth.action-types';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SitePlannerSharedAuthSessionManager implements SharedAuthSessionManager {
  constructor(private authService: AuthService) {}

  public ensureValidSession(options: SharedAuthSessionOptions): Promise<boolean> {
    return this.authService.ensureValidSession(options);
  }
}

@Injectable({
  providedIn: 'root',
})
export class SitePlannerInvalidSessionHandler implements SharedInvalidSessionHandler {
  private logoutDispatched = false;

  constructor(private store$: Store) {}

  public handleInvalidSession(): void {
    if (this.logoutDispatched) {
      return;
    }

    this.logoutDispatched = true;
    this.store$.dispatch(AuthActions.logout({ params: { msg: 'Session is invalid' } }));
  }
}
